module.exports = __webpack_public_path__ + "img/fc-midtjylland.165c2f1e.png";